import { Static, Optional, String, Boolean, Object, Array } from '@sinclair/typebox';

import { PartnerAwardSavedTraveler } from './travelers';

export type PartnerAawardSimpleProfile = Static<typeof PartnerAawardSimpleProfile>;
export const PartnerAawardSimpleProfile = Object({
  firstName: String(),
  lastName: String(),
  tier: Optional(String()),
});

export type PartnerAwardProfileResponse = Static<typeof PartnerAwardProfileResponse>;
export const PartnerAwardProfileResponse = Object({
  isSignedIn: Boolean(),
  profile: Optional(PartnerAawardSimpleProfile),
  savedTravelers: Array(PartnerAwardSavedTraveler),
  customerId: Optional(String()),
  customerType: Optional(String()),
  euroBonusNr: Optional(String()),
});
